// sophia-menu-icons.js - tags submenu items with metal/stone/category icons
// Top-level desktop header menu stays icon-free.
(function () {
  // ============================================================
  // EXCLUDE: any link matching these is never tagged
  // ============================================================
  var EXCLUDE = [
    /(?:^|[^a-z])bi[\s\-]?metal/i,
    /(?:^|[^a-z])(?:mixed|all|any|every)[\s\-]?metals?/i,
    /(?:^|[^a-z])metals?[\s\-]?guide/i,
    /(?:^|[^a-z])shop[\s\-]?(?:by[\s\-]?)?metals?/i,
    /(?:^|[^a-z])metal[\s\-]?types?/i,
    /^\s*by[\s\-]+(?:metal|gemstones?|stones?|occasion|color|style|shape|cut)/i,
    /(?:^|[^a-z])shop[\s\-]?(?:by[\s\-]?)?(?:gemstones?|stones?|occasion|color|style|shape|cut)/i,
    /(?:^|[^a-z])(?:all|every|any)[\s\-]?(?:gemstones?|stones?)/i,
    /(?:^|[^a-z])(?:gemstones?|stones?)[\s\-]?(?:guide|types?|categor|chart)/i,
    /(?:^|[^a-z])browse[\s\-]?(?:by|all)?/i,
  ];


  // ============================================================
  // SECTION HEADERS: items that act as labels/category separators
  // in submenus (not destinations). These get the .sj-section-header
  // class for bigger/bolder styling, and NEVER get an icon.
  // ============================================================
  var SECTION_HEADERS_TEXT = [
    /^\s*just[\s\-]?arrived\s*$/i,
    /^\s*featured?\s*$/i,
    /^\s*for[\s\-]?(?:him|her|kids?|teens?|men|women)\s*$/i,
    /^\s*new[\s\-]?(?:arrivals?|in|this[\s\-]?(?:week|month))\s*$/i,
    /^\s*best[\s\-]?sellers?\s*$/i,
    /^\s*top[\s\-]?(?:picks?|sellers?|rated)\s*$/i,
    /^\s*editor'?s?[\s\-]?picks?\s*$/i,
    /^\s*staff[\s\-]?picks?\s*$/i,
    /^\s*trending(?:[\s\-]?now)?\s*$/i,
    /^\s*popular\s*$/i,
    /^\s*essentials?\s*$/i,
    /^\s*highlights?\s*$/i,
    /^\s*signature(?:[\s\-]?(?:pieces?|collection))?\s*$/i,
    /^\s*shop[\s\-]?all(?:[\s\-]+[A-Za-z&'-]+)*\s*$/i,
    /^\s*shop[\s\-]?by(?:[\s\-]+[A-Za-z&'-]+)*\s*$/i,
    /^\s*shop[\s\-]?(?:the|now|here)\s*$/i,
    /^\s*view[\s\-]?all(?:[\s\-]+[A-Za-z&'-]+)*\s*$/i,
    /^\s*discover\s*$/i,
    /^\s*categor(?:y|ies)\s*$/i,
    /^\s*by[\s\-]+(?:metal|gemstones?|stones?|occasion|color|style|shape|cut|type|category)\s*$/i,
    /^\s*price[\s\-]?range\s*$/i,
    /^\s*occasions?\s*$/i,
  ];

  function isSectionHeader(el) {
    var text = (el.textContent || '').trim();
    // Pattern match
    for (var s = 0; s < SECTION_HEADERS_TEXT.length; s++) {
      if (SECTION_HEADERS_TEXT[s].test(text)) return true;
    }
    // Ella's heading classes
    if (el.classList.contains('mega-menu__link--level-2')) return true;
    if (el.classList.contains('header__submenu-heading')) return true;
    if (el.getAttribute('aria-disabled') === 'true') return true;
    // Structural: this <a> is followed by a sibling <ul> (it's a parent of more items)
    var li = el.closest('li');
    if (li) {
      var children = li.querySelectorAll(':scope > ul, :scope > ol');
      if (children.length > 0) return true;
    }
    return false;
  }

  // Returns the text of the section heading this item belongs to,
  // by walking up: <a> -> <li> -> <ul> -> <li> -> <a> (the heading).
  // Empty string if not nested inside a section group.
  function getSectionHeaderText(el) {
    var li = el.closest('li');
    if (!li) return '';
    var parentUl = li.parentElement;
    if (!parentUl) return '';
    var grandparentLi = parentUl.parentElement && parentUl.parentElement.closest('li');
    if (!grandparentLi) return '';
    var heading = grandparentLi.querySelector(':scope > a, :scope > details > summary, :scope > .mega-menu__link');
    if (heading) return (heading.textContent || '').trim();
    return '';
  }


  // ============================================================
  // CUSTOM CATEGORY ICONS - inline SVG, follows link color (gold on hover)
  // ============================================================
  var CUSTOM_ICONS = [
    [/(?:^|[^a-z])engagement[\s\-]?(?:ring|jewelry)/i,
     '<svg viewBox="0 0 24 24"><ellipse cx="12" cy="16" rx="6" ry="5"/><path d="M9 8 L12 4 L15 8 L12 11 Z"/></svg>'],
    [/(?:^|[^a-z])wedding[\s\-]?(?:band|ring|jewelry)/i,
     '<svg viewBox="0 0 24 24"><ellipse cx="12" cy="13" rx="7.5" ry="6.5"/><ellipse cx="12" cy="13" rx="5" ry="4" opacity="0.4"/></svg>'],
    [/(?:^|[^a-z])anniversary|eternity/i,
     '<svg viewBox="0 0 24 24"><ellipse cx="12" cy="13" rx="7.5" ry="6.5"/><circle cx="12" cy="6.5" r="1"/><circle cx="6" cy="13" r="1"/><circle cx="18" cy="13" r="1"/><circle cx="12" cy="19.5" r="1"/></svg>'],
    [/(?:^|[^a-z])earrings?/i,
     '<svg viewBox="0 0 24 24"><path d="M10 4 a2 2 0 0 1 4 0"/><path d="M12 6 L12 13"/><circle cx="12" cy="17" r="3.5"/></svg>'],
    [/(?:^|[^a-z])necklaces?/i,
     '<svg viewBox="0 0 24 24"><path d="M4 6 Q12 18 20 6"/><circle cx="12" cy="17" r="2"/></svg>'],
    [/(?:^|[^a-z])pendants?/i,
     '<svg viewBox="0 0 24 24"><path d="M5 5 L19 5"/><path d="M12 5 L12 11 Q8 11 8 15.5 Q8 20 12 20 Q16 20 16 15.5 Q16 11 12 11"/></svg>'],
    [/(?:^|[^a-z])(?:bracelets?|bangles?|cuffs?)/i,
     '<svg viewBox="0 0 24 24"><ellipse cx="12" cy="13" rx="9" ry="5.5"/><circle cx="12" cy="7.5" r="0.9" fill="currentColor"/></svg>'],
    [/(?:^|[^a-z])(?:rings?|toe[\s\-]?rings?)(?![\s\-]?(?:tone|setting|engage|wedd))/i,
     '<svg viewBox="0 0 24 24"><circle cx="12" cy="14" r="6"/><path d="M10 6 L12 3 L14 6 Z" fill="currentColor"/></svg>'],
    [/(?:^|[^a-z])charms?/i,
     '<svg viewBox="0 0 24 24"><path d="M5 7 L19 7"/><circle cx="9" cy="14" r="3"/><path d="M14 14 L18 14 L18 18 L14 18 Z"/></svg>'],
    [/(?:^|[^a-z])watch(?:es)?/i,
     '<svg viewBox="0 0 24 24"><rect x="7" y="8" width="10" height="8" rx="1.5"/><path d="M9.5 8 L9.5 4 L14.5 4 L14.5 8"/><path d="M9.5 16 L9.5 20 L14.5 20 L14.5 16"/></svg>'],
    [/(?:^|[^a-z])men(?:s|\'s)?(?:[\s\-]?jewelry)?/i,
     '<svg viewBox="0 0 24 24"><circle cx="10" cy="14" r="5"/><path d="M14 10 L20 4"/><path d="M14.5 4 L20 4 L20 9.5"/></svg>'],
    [/(?:^|[^a-z])bridal/i,
     '<svg viewBox="0 0 24 24"><path d="M12 19 C 4 13, 4 4, 12 8 C 20 4, 20 13, 12 19 Z"/></svg>'],
    [/(?:^|[^a-z])gifts?(?:[\s\-]?(?:for|guide))?/i,
     '<svg viewBox="0 0 24 24"><rect x="4" y="9" width="16" height="11"/><path d="M4 13 L20 13"/><path d="M12 9 L12 20"/><path d="M9 6 C 8 3, 12 3, 12 9 C 12 3, 16 3, 15 6"/></svg>'],
    [/(?:^|[^a-z])sale|clearance|outlet/i,
     '<svg viewBox="0 0 24 24"><path d="M3 12 L12 3 L21 3 L21 12 L12 21 Z"/><circle cx="16" cy="8" r="1.6"/></svg>'],
    [/(?:^|[^a-z])(?:new[\s\-]?in|new[\s\-]?arrival|just[\s\-]?in|whats[\s\-]?new)/i,
     '<svg viewBox="0 0 24 24"><path d="M12 2 L13.5 10 L21 12 L13.5 14 L12 22 L10.5 14 L3 12 L10.5 10 Z"/></svg>'],
    [/(?:^|[^a-z])(?:journal|blog|magazine|stories)/i,
     '<svg viewBox="0 0 24 24"><path d="M4 4 L11 4 L12 5 L13 4 L20 4 L20 20 L13 20 L12 19 L11 20 L4 20 Z"/><path d="M12 5 L12 19"/></svg>'],
    [/(?:^|[^a-z])(?:all[\s\-]?jewelry|shop[\s\-]?all|view[\s\-]?all)/i,
     '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="7.5" height="7.5"/><rect x="13.5" y="3" width="7.5" height="7.5"/><rect x="3" y="13.5" width="7.5" height="7.5"/><rect x="13.5" y="13.5" width="7.5" height="7.5"/></svg>'],
    [/(?:^|[^a-z])collections?/i,
     '<svg viewBox="0 0 24 24"><path d="M4 5 L20 5 L18 19 L6 19 Z"/><path d="M4 9 L20 9"/></svg>'],
  ];

  // ============================================================
  // METAL + STONE rules (colored circles + gem shapes)
  // ============================================================
  var RULES = [
    // --- BRACELET GEM/PEARL/METAL COMPOSITE RULES (must run before generic gem/pearl/metal) ---
    ['', 'sj-mi-style-bracelet-pearl',        /(?:^|[^a-z])pearl[\s\-]?bracelet/i],
    ['', 'sj-mi-pearl-bracelet-freshwater',    /(?:^|[^a-z])freshwater[\s\-]?(?:pearl[\s\-]?)?bracelet/i],
    ['', 'sj-mi-pearl-bracelet-akoya',         /(?:^|[^a-z])akoya[\s\-]?(?:pearl[\s\-]?)?bracelet/i],
    ['', 'sj-mi-metal-bracelet-platinum',      /(?:^|[^a-z])platinum[\s\-]?bracelet/i],
    ['', 'sj-mi-metal-bracelet-yellow-gold',   /(?:^|[^a-z])yellow[\s\-]?gold[\s\-]?bracelet/i],
    ['', 'sj-mi-metal-bracelet-rose-gold',     /(?:^|[^a-z])rose[\s\-]?gold[\s\-]?bracelet/i],
    ['', 'sj-mi-metal-bracelet-white-gold',    /(?:^|[^a-z])white[\s\-]?gold[\s\-]?bracelet/i],
    ['', 'sj-mi-style-bracelet-anniversary',  /(?:^|[^a-z])anniversary[\s\-]?(?:gifts?|bracelet)/i],
    // --- BRACELET STYLES COLUMN RULES (must run before generic rules; specific matches) ---
    ['', 'sj-mi-style-bracelet-bead',          /(?:^|[^a-z])(?:bead|beaded)[\s\-,]+(?:and[\s\-]+beaded[\s\-]+)?bracelet/i],
    ['', 'sj-mi-style-bracelet-charm',         /(?:^|[^a-z])charm[\s\-]?bracelet/i],
    ['', 'sj-mi-style-bracelet-childrens',     /(?:^|[^a-z])(?:children'?s?|kids?)[\s\-]?bracelet/i],
    ['', 'sj-mi-style-bracelet-contemporary',  /(?:^|[^a-z])contemporary[\s\-]?bracelet/i],
    ['', 'sj-mi-style-bracelet-cord',          /(?:^|[^a-z])(?:cord|leather|rubber)[\s\-,]/i],
    ['', 'sj-mi-style-bracelet-cuff',          /(?:^|[^a-z])cuff[\s\-]?bracelet/i],
    ['', 'sj-mi-style-bracelet-fancy',         /(?:^|[^a-z])fancy[\s\-]?bracelet/i],
    ['', 'sj-mi-style-bracelet-gemstone',      /(?:^|[^a-z])gemstone[\s\-]?bracelet/i],
    ['', 'sj-mi-style-bracelet-id',            /(?:^|[^a-z])id[\s\-]?bracelet/i],
    ['', 'sj-mi-style-bracelet-link',          /(?:^|[^a-z])link[\s\-]?bracelet/i],
    ['', 'sj-mi-style-bracelet-medical',       /(?:^|[^a-z])medical[\s\-]?bracelet/i],
    ['', 'sj-mi-style-bracelet-themed',        /(?:^|[^a-z])themed[\s\-]?bracelet/i],
    ['', 'sj-mi-style-bracelet-bangle',       /(?:^|[^a-z])bangle/i],
    // --- GIFT MENU RULES ---
    ['', 'sj-mi-gift-price-luxe',          /(?:^|[^a-z])luxe[\s\-]?gifts?/i],
    ['', 'sj-mi-gift-price-high',          /(?:^|[^a-z])under[\s\-]?\$?2[,]?000/i],
    ['', 'sj-mi-gift-price-mid',           /(?:^|[^a-z])under[\s\-]?\$?1[,]?000/i],
    ['', 'sj-mi-gift-price-low',           /(?:^|[^a-z])under[\s\-]?\$?500/i],
    ['', 'sj-mi-gift-occasion-mothers-day',  /(?:^|[^a-z])mother'?s?[\s\-]?day/i],
    ['', 'sj-mi-gift-occasion-anniversary',  /^anniversary(?![a-z])/i],
    ['', 'sj-mi-gift-occasion-birthday',     /^birthday(?![a-z])/i],
    ['', 'sj-mi-gift-occasion-push-present', /(?:^|[^a-z])push[\s\-]?present/i],
    ['', 'sj-mi-gift-occasion-promise-rings',/(?:^|[^a-z])promise[\s\-]?rings?/i],
    ['', 'sj-mi-gift-occasion-wedding',      /^wedding(?![a-z])/i],
    ['', 'sj-mi-gift-occasion-graduation',   /^graduation(?![a-z])/i],
    ['', 'sj-mi-gift-occasion-thanksgiving', /^thanksgiving(?![a-z])/i],
    ['', 'sj-mi-gift-occasion-valentines',   /^valentine'?s?(?![a-z])/i],
    ['', 'sj-mi-gift-occasion-christmas',    /^christmas(?![a-z])/i],
    ['', 'sj-mi-gift-recipient-her',        /(?:^|[^a-z])gifts?[\s\-]?for[\s\-]?her/i],
    ['', 'sj-mi-gift-recipient-him',        /(?:^|[^a-z])gifts?[\s\-]?for[\s\-]?him/i],
    ['', 'sj-mi-gift-category-rings',      /^rings(?![a-z])/i],
    ['', 'sj-mi-gift-category-necklaces',  /^necklaces(?![a-z])/i],
    ['', 'sj-mi-gift-category-earrings',   /^earrings(?![a-z])/i],
    ['', 'sj-mi-gift-category-bracelets',  /^bracelets(?![a-z])/i],
    ['', 'sj-mi-gift-personalized-zodiac',   /(?:^|[^a-z])zodiac[\s\-]?jewelry/i],
    ['', 'sj-mi-gift-personalized-initials', /^initials(?![a-z])/i],
    ['', 'sj-mi-gift-featured-mothers-day', /(?:^|[^a-z])mother'?s?[\s\-]?day[\s\-]?gifts?/i],
    ['', 'sj-mi-gift-featured-gemstone',    /(?:^|[^a-z])gemstone[\s\-]?gifts?/i],

    // --- BRACELET-SPECIFIC RULES ---
    ['', 'sj-mi-dia-colored-diamond-bracelets', /(?:^|[^a-z])color(?:ed)?[\s\-]?diamond[\s\-]?bracelet/i],
    ['', 'sj-mi-dia-diamond-bracelets',         /(?:^|[^a-z])diamond[\s\-]?bracelet/i],
    ['', 'sj-mi-style-bracelet-stackable',      /(?:^|[^a-z])stackable[\s\-]?bracelet/i],
    ['', 'sj-mi-style-bracelet-fashion',        /(?:^|[^a-z])fashion[\s\-]?bracelet/i],
    ['', 'sj-mi-style-bracelet-chain',          /(?:^|[^a-z])chain[\s\-]?bracelet/i],
    ['', 'sj-mi-style-bracelet-tennis',         /(?:^|[^a-z])tennis[\s\-]?bracelet/i],
    ['', 'sj-mi-style-bracelet-adjustable',     /(?:^|[^a-z])adjustable[\s\-]?bracelet/i],
    ['', 'sj-mi-style-bracelet-initial',        /(?:^|[^a-z])(?:initial|initials)[\s\-]?bracelet/i],
    ['', 'sj-mi-style-bracelet-best-seller',    /(?:^|[^a-z])best[\s\-]?(?:selling|seller)[\s\-]?bracelet/i],
    ['', 'sj-mi-style-bracelet-mens',           /(?:^|[^a-z])(?:men'?s?|mens)[\s\-]?bracelet/i],
    // --- WEDDING BAND-SPECIFIC RULES (must run before wedding-ring + generic rules) ---
    ['', 'sj-mi-style-band-set',              /(?:^|[^a-z])(?:wedding[\s\-]?)?band[\s\-]?set/i],
    ['', 'sj-mi-style-band-guards-wraps',     /(?:^|[^a-z])(?:guards?|wraps?)(?:[\s\-]?(?:&|and)[\s\-]?(?:guards?|wraps?))?/i],
    ['', 'sj-mi-style-band-grooved',          /(?:^|[^a-z])grooved[\s\-]?band/i],
    ['', 'sj-mi-style-band-inlayed',          /(?:^|[^a-z])inlay(?:ed)?[\s\-]?band/i],
    ['', 'sj-mi-style-band-gemstone-diamond', /(?:^|[^a-z])gemstone[\s\-]?(?:&|and|\+)?[\s\-]?diamond[\s\-]?band/i],
    ['', 'sj-mi-style-band-fancy',            /(?:^|[^a-z])fancy[\s\-]?band/i],
    ['', 'sj-mi-style-band-diamond',          /(?:^|[^a-z])diamond[\s\-]?band/i],
    ['', 'sj-mi-style-band-themed',           /(?:^|[^a-z])(?:themed|designed[\s\-]?themed)[\s\-]?band/i],
    ['', 'sj-mi-style-band-decorative',       /(?:^|[^a-z])decorative[\s\-]?band/i],
    ['', 'sj-mi-style-band-classic',          /(?:^|[^a-z])classic[\s\-]?(?:wedding[\s\-]?)?band/i],
    // --- WEDDING-RING-SPECIFIC RULES (must run before generic ring style rules) ---
    ['', 'sj-mi-style-ring-bridal-set',    /(?:^|[^a-z])bridal[\s\-]?set/i],
    ['', 'sj-mi-style-ring-eternity',      /(?:^|[^a-z])eternity[\s\-]?(?:wedding|anniversary|ring|band)/i],
    ['', 'sj-mi-style-ring-non-eternity',  /(?:^|[^a-z])non[\s\-]?eternity/i],
    ['', 'sj-mi-style-ring-plain',         /(?:^|[^a-z])plain[\s\-]?(?:wedding|ring|band)/i],
    ['', 'sj-mi-style-ring-fashion',       /(?:^|[^a-z])fashion[\s\-]?(?:wedding|ring)/i],
    ['', 'sj-mi-style-ring-anniversary',   /(?:^|[^a-z])anniversary[\s\-]?(?:ring|band)/i],
    // --- NECKLACE-SPECIFIC RULES (must run before generic diamond/style/shape rules) ---
    ['', 'sj-mi-dia-colored-diamond-necklaces', /(?:^|[^a-z])color(?:ed)?[\s\-]?diamond[\s\-]?necklace/i],
    ['', 'sj-mi-dia-diamond-necklaces',         /(?:^|[^a-z])diamond[\s\-]?necklace/i],
    ['', 'sj-mi-style-necklace-name',           /(?:^|[^a-z])name[\s\-]?necklace/i],
    ['', 'sj-mi-style-necklace-cross',          /(?:^|[^a-z])cross[\s\-]?necklace/i],
    ['', 'sj-mi-style-necklace-solitaire',      /(?:^|[^a-z])solitaire[\s\-]?necklace/i],
    ['', 'sj-mi-style-necklace-fashion',        /(?:^|[^a-z])fashion[\s\-]?necklace/i],
    ['', 'sj-mi-style-necklace-classic',        /(?:^|[^a-z])classic[\s\-]?necklace/i],
    ['', 'sj-mi-style-necklace-tennis',         /(?:^|[^a-z])tennis[\s\-]?necklace/i],
    ['', 'sj-mi-style-necklace-chain',          /(?:^|[^a-z])chain[\s\-]?necklace/i],
    ['', 'sj-mi-style-necklace-initial',        /(?:^|[^a-z])initial[\s\-]?necklace/i],
    ['', 'sj-mi-style-necklace-mens',           /(?:^|[^a-z])(?:men'?s?|mens)[\s\-]?necklace/i],
    ['', 'sj-mi-style-necklace-anniversary',    /(?:^|[^a-z])anniversary[\s\-]?necklace/i],
    ['', 'sj-mi-style-necklace-best-seller',    /(?:^|[^a-z])best[\s\-]?(?:selling|seller)[\s\-]?necklace/i],
    ['', 'sj-mi-shape-necklace-round',          /(?:^|[^a-z])round[\s\-]?necklace/i],
    ['', 'sj-mi-shape-necklace-oval',           /(?:^|[^a-z])oval[\s\-]?necklace/i],
    ['', 'sj-mi-shape-necklace-pear',           /(?:^|[^a-z])pear[\s\-]?necklace/i],
    ['', 'sj-mi-shape-necklace-cushion',        /(?:^|[^a-z])cushion[\s\-]?necklace/i],
    ['', 'sj-mi-shape-round',       /(?:^|[^a-z])round(?:[\s\-]+(?:rings?|earrings?|cut))/i],
    ['', 'sj-mi-shape-oval',        /(?:^|[^a-z])oval(?:[\s\-]+(?:rings?|earrings?|cut))/i],
    ['', 'sj-mi-shape-pear',        /(?:^|[^a-z])pear(?:[\s\-]+(?:rings?|earrings?|cut|shape))/i],
    ['', 'sj-mi-shape-emerald-cut', /(?:^|[^a-z])emerald[\s\-]?cut/i],
    ['YG', 'sj-mi-yg', /(?:^|[^a-z])yellow[\s\-]?gold/i],
    ['WG', 'sj-mi-wg', /(?:^|[^a-z])white[\s\-]?gold/i],
    ['RG', 'sj-mi-rg', /(?:^|[^a-z])rose[\s\-]?gold/i],
    ['PT', 'sj-mi-pt', /(?:^|[^a-z])platinum/i],
    ['SS', 'sj-mi-ss', /(?:^|[^a-z])(?:sterling[\s\-]?silver|silver(?!\s*plated))/i],
    ['TT', 'sj-mi-tt', /(?:^|[^a-z])two[\s\-]?tone/i],
    ['FS', 'sj-mi-fs', /(?:^|[^a-z])fine[\s\-]?silver/i],
    ['NS', 'sj-mi-ns', /(?:^|[^a-z])nickel[\s\-]?silver/i],
    ['TI', 'sj-mi-ti', /(?:^|[^a-z])titanium/i],
    ['TU', 'sj-mi-tu', /(?:^|[^a-z])tungsten/i],
    ['PD', 'sj-mi-pd', /(?:^|[^a-z])palladium/i],
    ['BR', 'sj-mi-br', /(?:^|[^a-z])brass/i],
    ['ST', 'sj-mi-st', /(?:^|[^a-z])stainless[\s\-]?steel/i],
    ['DS', 'sj-mi-ds', /(?:^|[^a-z])damascus/i],
    ['MT', 'sj-mi-mt', /(?:^|[^a-z])meteorite/i],
    ['CF', 'sj-mi-cf', /(?:^|[^a-z])carbon[\s\-]?fiber/i],
    ['CO', 'sj-mi-co', /(?:^|[^a-z])cobalt(?![\s\-]?chrome)/i],
    ['CC', 'sj-mi-cc', /(?:^|[^a-z])cobalt[\s\-]?chrome/i],
    ['CB', 'sj-mi-cb', /(?:^|[^a-z])ceramic[\s\-]?black|black[\s\-]?ceramic/i],
    ['CW', 'sj-mi-cw', /(?:^|[^a-z])ceramic[\s\-]?white|white[\s\-]?ceramic|(?:^|[^a-z])ceramic(?![\s\-]?black)/i],
    ['ZR', 'sj-mi-zr', /(?:^|[^a-z])zirconium(?![\s\-]?black)/i],
    ['BZ', 'sj-mi-bz', /(?:^|[^a-z])black[\s\-]?zirconium/i],
    ['', 'sj-mi-labdiamond', /(?:^|[^a-z])lab[\s\-]?(?:grown[\s\-]?)?diamond/i],
    ['', 'sj-mi-moissanite', /(?:^|[^a-z])moissanite/i],
    ['', 'sj-mi-dia-diamond-stud-earrings',    /(?:^|[^a-z])diamond[\s\-]?stud[\s\-]?earring/i],
    ['', 'sj-mi-dia-diamond-hoop-earrings',    /(?:^|[^a-z])diamond[\s\-]?hoop[\s\-]?earring/i],
    ['', 'sj-mi-dia-diamond-bands',            /(?:^|[^a-z])diamond[\s\-]?band/i],
    ['', 'sj-mi-dia-colored-diamond-rings',    /(?:^|[^a-z])color(?:ed)?[\s\-]?diamond[\s\-]?ring/i],
    ['', 'sj-mi-dia-colored-diamond-earrings', /(?:^|[^a-z])color(?:ed)?[\s\-]?diamond[\s\-]?earring/i],
    ['', 'sj-mi-dia-diamond-rings',            /(?:^|[^a-z])diamond[\s\-]?ring/i],
    ['', 'sj-mi-dia-diamond-earrings',         /(?:^|[^a-z])diamond[\s\-]?earring/i],
    ['', 'sj-mi-diamond',    /(?:^|[^a-z])diamond(?![a-z])/i],
    ['', 'sj-mi-sapphire',   /(?:^|[^a-z])sapphire/i],
    ['', 'sj-mi-ruby',       /(?:^|[^a-z])(?:ruby|rubies)/i],
    ['', 'sj-mi-emerald',    /(?:^|[^a-z])emerald/i],
    ['', 'sj-mi-pearl-akoya', /(?:^|[^a-z])akoya/i],
    ['', 'sj-mi-pearl-freshwater', /(?:^|[^a-z])freshwater/i],
    ['', 'sj-mi-pearl-southsea', /(?:^|[^a-z])south[\s\-]?sea/i],
    ['', 'sj-mi-pearl-tahitian', /(?:^|[^a-z])tahitian/i],
    ['', 'sj-mi-pearl',      /(?:^|[^a-z])pearl/i],
    ['', 'sj-mi-amethyst',   /(?:^|[^a-z])amethyst/i],
    ['', 'sj-mi-topaz',      /(?:^|[^a-z])topaz/i],
    ['', 'sj-mi-aquamarine', /(?:^|[^a-z])aquamarine/i],
    ['', 'sj-mi-citrine',    /(?:^|[^a-z])citrine/i],
    ['', 'sj-mi-garnet',     /(?:^|[^a-z])garnet/i],
    ['', 'sj-mi-peridot',    /(?:^|[^a-z])peridot/i],
    ['', 'sj-mi-tanzanite',  /(?:^|[^a-z])tanzanite/i],
    ['', 'sj-mi-opal',       /(?:^|[^a-z])opal/i],
    ['', 'sj-mi-onyx',       /(?:^|[^a-z])onyx/i],
    ['', 'sj-mi-tourmaline', /(?:^|[^a-z])tourmaline/i],
    ['', 'sj-mi-birthstone', /(?:^|[^a-z])birthstone/i],
    ['', 'sj-mi-style-ring-stackable',   /(?:^|[^a-z])stackable/i],
    ['', 'sj-mi-style-ring-vintage',     /(?:^|[^a-z])vintage/i],
    ['', 'sj-mi-style-ring-side-stone',  /(?:^|[^a-z])side[\s\-]?stone/i],
    ['', 'sj-mi-style-ring-halo',        /(?:^|[^a-z])halo/i],
    ['', 'sj-mi-style-ring-solitaire',   /(?:^|[^a-z])solitaire/i],
    ['', 'sj-mi-style-ring-classic',     /(?:^|[^a-z])classic[\s\-]+ring/i],
    ['', 'sj-mi-style-earring-ball-button',   /(?:^|[^a-z])ball[\s\-]?(?:&[\s\-]?)?button/i],
    ['', 'sj-mi-style-earring-drop-dangle',   /(?:^|[^a-z])(?:drop[\s\-]?(?:&[\s\-]?)?dangle|drop[\s\-]+earrings?)/i],
    ['', 'sj-mi-style-earring-climber',       /(?:^|[^a-z])ear[\s\-]?climber/i],
    ['', 'sj-mi-style-earring-jacket',        /(?:^|[^a-z])earring[\s\-]?jacket/i],
    ['', 'sj-mi-style-earring-set',           /(?:^|[^a-z])earring[\s\-]?set(?![a-z])/i],
    ['', 'sj-mi-style-earring-hoop',          /(?:^|[^a-z])hoop/i],
    ['', 'sj-mi-style-earring-non-pierced',   /(?:^|[^a-z])non[\s\-]?pierced/i],
    ['', 'sj-mi-style-earring-themed',        /(?:^|[^a-z])themed/i],
    ['', 'sj-mi-style-ring-classic',     /(?:^|[^a-z])classic[\s\-]+earring/i],
  ];

  // Containers in which icons ARE allowed.
  // Anything NOT inside one of these is treated as top-level header (no icon).
  var ALLOW_CONTAINERS = '.header__submenu, .mega-menu__content, .menu-drawer';

  // Selectors of clickable items we consider for tagging.
  var SELECTORS = [
    '.list-menu__item--link',
    '.header__menu-item',
    '.menu-drawer__menu-item',
    'a',
  ];

  function tag(root) {
    var nodes = root.querySelectorAll(SELECTORS.join(','));
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.classList.contains('sj-mi') || el.classList.contains('sj-ci-tagged')) continue;

      // Only tag items inside an allowed container (submenu / mega-menu / drawer / footer).
      // Top-level desktop header items are excluded.
      if (!el.closest(ALLOW_CONTAINERS)) continue;

      var text = (el.textContent || '').trim();
      var href = (el.getAttribute('href') || '').trim();
      if (!text) continue;
      if (!href || href === '#' || href === 'javascript:void(0)') continue;
      var hay = text + ' ' + href;

      // 0) SECTION HEADER detection FIRST - so "By Style" / "Shop By Metal"
      //    style as headers even though they would otherwise be in EXCLUDE.
      if (isSectionHeader(el)) {
        el.classList.add('sj-section-header');
        continue;
      }

      // EXPLORE links: 'Explore All', 'Explore Bridal', etc. Get a subtle
      // 'see more' style — smaller, lighter — instead of bold header style.
      if (/^\s*explore\b/i.test(text)) {
        el.classList.add('sj-explore-link');
        continue;
      }

      // 1) EXCLUDE: any non-header item matching these gets no icon (still rendered as plain text)
      var skip = false;
      for (var k = 0; k < EXCLUDE.length; k++) {
        if (EXCLUDE[k].test(hay)) { skip = true; break; }
      }
      if (skip) continue;

      // 0.5) SECTION CONTEXT - if parent section is "By Metal" / "By Gemstone",
      // force the metal/stone icon to win over the category (custom) icon.
      var sectionHeader = getSectionHeaderText(el);
      var forceMetal = /^\s*by[\s\-]+metal/i.test(sectionHeader);
      var forceStone = /^\s*by[\s\-]+(?:gemstones?|stones?|color|colour)/i.test(sectionHeader);
      if (forceMetal || forceStone) {
        var found = false;
        for (var m = 0; m < RULES.length; m++) {
          var rLabel = RULES[m][0], rCls = RULES[m][1], rPat = RULES[m][2];
          var isMetalRule = (rCls === 'sj-mi-yg' || rCls === 'sj-mi-wg' || rCls === 'sj-mi-rg' || rCls === 'sj-mi-pt' || rCls === 'sj-mi-ss' || rCls === 'sj-mi-tt');
          if (forceMetal && !isMetalRule) continue;
          if (forceStone && isMetalRule) continue;
          if (rPat.test(hay)) {
            el.classList.add('sj-mi', rCls);
            if (rLabel) el.setAttribute('data-sj-mi-label', rLabel);
            found = true;
            break;
          }
        }
        if (found) continue;
        // No metal/stone match in a By-Metal/By-Stone section -> skip icon entirely
        // (don't fall through to custom category icons)
        continue;
      }

      // 1) METAL / STONE detection FIRST — gem/metal name in text or URL
      //    wins over generic category icons. So 'Blue Sapphire Rings' gets
      //    the sapphire gem icon instead of the generic rings icon.
      var rulesMatched = false;
      for (var j = 0; j < RULES.length; j++) {
        var label = RULES[j][0], cls = RULES[j][1], pat = RULES[j][2];
        if (pat.test(hay)) {
          el.classList.add('sj-mi', cls);
          if (label) el.setAttribute('data-sj-mi-label', label);
          rulesMatched = true;
          break;
        }
      }
      if (rulesMatched) continue;

      // 2) CUSTOM ICONS fallback - generic category icons for items with no
      //    gem/metal in name. Test against TEXT ONLY (not text+href haystack)
      //    — otherwise /^collections?$/ would match every /collections/X URL.
      var matched = false;
      for (var c = 0; c < CUSTOM_ICONS.length; c++) {
        if (CUSTOM_ICONS[c][0].test(text)) {
          var span = el.ownerDocument.createElement('span');
          span.className = 'sj-ci';
          span.setAttribute('aria-hidden', 'true');
          span.innerHTML = CUSTOM_ICONS[c][1];
          if (el.firstChild) el.insertBefore(span, el.firstChild);
          else el.appendChild(span);
          el.classList.add('sj-ci-tagged');
          matched = true;
          break;
        }
      }
    }
  }

  function init() { tag(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', function () { tag(document); });
  if (window.MutationObserver) {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { tag(document); break; }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
